import React, { useEffect, useState } from 'react';

import axios from 'axios';

import routes from '../routesConfig';

function RouteDropdownPage() {

    const [withParent, setWithParent] = useState([]);

    const [withoutParent, setWithoutParent] = useState([]);

    const [selectedParentId, setSelectedParentId] = useState('');

    const [selectedChildId, setSelectedChildId] = useState('');

    const [addingNew, setAddingNew] = useState(false);

    const [newMenuName, setNewMenuName] = useState('');

    // Load local routes (children)

    useEffect(() => {

        const mappedRoutes = routes.map((r, index) => ({

            Id: index + 1,

            menuLink: r.path,

            menuName: r.label,

        }));

        setWithParent(mappedRoutes);

    }, []);

    // Load parent menus from backend

    useEffect(() => {

        const fetchWithoutParent = async () => {

            try {

                const res = await axios.get('/api/route-lookup/without-parent');

                console.log('withoutParent data:', res.data);  // Inspect data

                setWithoutParent(res.data);

            } catch (error) {

                console.error('Error fetching routes without parent:', error);

            }

        };

        fetchWithoutParent();

    }, []);

    // Handle selects

    const handleParentChange = (e) => {

        setSelectedParentId(e.target.value);

    };

    const handleChildChange = (e) => {

        setSelectedChildId(e.target.value);

    };

    // Add new parent menu

    const handleAddNewMenu = async () => {

        if (!newMenuName.trim()) {

            alert('Menu name is required.');

            return;

        }

        const newMenu = {

            MenuName: newMenuName.trim(),

            MenuLink: '/',

            Parentmenuid: 0,

            IsActive: 1,

        };

        try {

            await axios.post('/api/route-lookup/add-parent', newMenu);

            setNewMenuName('');

            setAddingNew(false);

            const res = await axios.get('/api/route-lookup/without-parent');

            setWithoutParent(res.data);

            alert('New menu added successfully.');

        } catch (error) {

            console.error('Error adding new menu:', error);

            alert('Failed to add new menu.');

        }

    };

    // Insert child menu with selected parent id — UPDATED

    const handleInsertMenu = async () => {

        if (!selectedParentId) {

            alert('Please select a parent menu.');

            return;

        }

        if (!selectedChildId) {

            alert('Please select a child menu.');

            return;

        }

        // Find selected child menu details from withParent

        const selectedChild = withParent.find(route => route.Id.toString() === selectedChildId);

        if (!selectedChild) {

            alert('Selected child menu not found.');

            return;

        }

        const newChildMenu = {

            MenuName: selectedChild.menuName,

            MenuLink: selectedChild.menuLink,

            Parentmenuid: parseInt(selectedParentId),

            IsActive: 1,

        };

        try {

            // Use the add-child endpoint here

            await axios.post('/api/route-lookup/add-child', newChildMenu);

            alert('Child menu inserted successfully.');

            console.log('newChildMenu:', newChildMenu);

            // Optionally reload parent menus

            const res = await axios.get('/api/route-lookup/without-parent');

            setWithoutParent(res.data);

            // Reset selections

            setSelectedParentId('');

            setSelectedChildId('');

        } catch (error) {

            console.error('Error inserting child menu:', error);

            alert('Failed to insert child menu.');

        }

    };

    return (
        <div style={{ padding: '1rem' }}>
            <h1>Route Navigation</h1>

            {/* Parent Menu Dropdown */}
            <div style={{ marginBottom: '1rem' }}>
                <h3>Select Parent Menu</h3>
                <select

                    value={selectedParentId}

                    onChange={handleParentChange}

                    className="form-control"

                    style={{ width: '300px' }}
                >
                    <select

                        value={selectedParentId}

                        onChange={handleParentChange}
                    >
                        <option value="">-- Select Parent Menu --</option>

                        {withoutParent.map(route => (
                            <option key={route.Id} value={route.Id}>

                                {route.menuName}
                            </option>

                        ))}
                    </select>

                </select>
            </div>

            {/* Child Menu Dropdown */}
            <div style={{ marginBottom: '1rem' }}>
                <h3>Select Child Menu (from local routes)</h3>
                <select

                    value={selectedChildId}

                    onChange={handleChildChange}

                    className="form-control"

                    style={{ width: '300px' }}
                >
                    <option value="">-- Select Child Menu --</option>

                    {withParent.map(route => (
                        <option key={route.Id} value={route.Id}>

                            {route.menuName}
                        </option>

                    ))}
                </select>
            </div>

            {/* Insert Button */}
            <button onClick={handleInsertMenu} className="btn btn-success" style={{ marginRight: '1rem' }}>

                Insert Menu
            </button>

            {/* Optional: Add new parent menu */}
            <button onClick={() => setAddingNew(true)} className="btn btn-primary">

                Add New Parent Menu
            </button>

            {addingNew && (
                <div style={{ marginTop: '1rem' }}>
                    <input

                        type="text"

                        className="form-control mb-2"

                        placeholder="Enter new parent menu name"

                        value={newMenuName}

                        onChange={e => setNewMenuName(e.target.value)}

                        style={{ width: '300px' }}

                    />
                    <button onClick={handleAddNewMenu} className="btn btn-primary">

                        Add Menu
                    </button>
                    <button onClick={() => setAddingNew(false)} className="btn btn-secondary" style={{ marginLeft: '8px' }}>

                        Cancel
                    </button>
                </div>

            )}
        </div>

    );

}

export default RouteDropdownPage;

